/* eslint no-console: 0 */
import * as types from '../mutation-types';
import ManagementChartsAPI from '../../api/managementCharts';
import { clampDataBetweenTimeline } from 'shared/helpers/ReportsDataHelper';

const state = {
  fetchingStatus: false,
  dailyAttendanceByHour: {
    isFetching: false,
    data: [],
  },
  totalServiceTime: {
    isFetching: false,
    data: [],
  },
};

const getters = {
  getDailyAttendanceByHour(_state) {
    return _state.dailyAttendanceByHour.data;
  },
  getTotalServiceTime(_state) {
    return _state.totalServiceTime.data;
  },
};

export const actions = {
  fetchDailyAttendanceByHour({ commit }, reportObj) {
    commit(types.default.SET_DAILY_ATTENDANCE_BY_HOUR_LOADING, true);
    ManagementChartsAPI.getDailyAttendanceByHour(reportObj).then(response => {
      let { data } = response;
      data = clampDataBetweenTimeline(data, reportObj.from, reportObj.to);
      commit(types.default.SET_DAILY_ATTENDANCE_BY_HOUR, data);
      commit(types.default.SET_DAILY_ATTENDANCE_BY_HOUR_LOADING, false);
    });
  },
  fetchTotalServiceTime({ commit }, reportObj) {
    commit(types.default.SET_TOTAL_SERVICE_TIME_LOADING, true);
    ManagementChartsAPI.getTotalServiceTime(reportObj).then(response => {
      const { data } = response;
      commit(types.default.SET_TOTAL_SERVICE_TIME, data);
      commit(types.default.SET_TOTAL_SERVICE_TIME_LOADING, false);
    });
  },
};

const mutations = {
  [types.default.SET_DAILY_ATTENDANCE_BY_HOUR](_state, data) {
    _state.dailyAttendanceByHour.data = data;
  },
  [types.default.SET_DAILY_ATTENDANCE_BY_HOUR_LOADING](_state, value) {
    _state.dailyAttendanceByHour.isFetching = value;
  },
  [types.default.SET_TOTAL_SERVICE_TIME](_state, data) {
    _state.totalServiceTime.data = data;
  },
  [types.default.SET_TOTAL_SERVICE_TIME_LOADING](_state, value) {
    _state.totalServiceTime.isFetching = value;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
